<template>
  <div id="page-forms">
    <v-container fluid>
      <v-form
        v-model="valid"
        ref="formValid"
        lazy-validation
      >
        <v-layout
          row
          wrap
        >

          <v-flex
            lg4
            sm4
          >
            <v-text-field
              label="Name of Event"
              placeholder=""
              prepend-icon="vertical_split"
              v-model="form.name"
              ref="name"
            ></v-text-field>
          </v-flex>
          <v-flex
            lg4
            sm4
          >

            <v-autocomplete              
              hint="Atleast 3 Characters required"   
              chips              
              flat
              placeholder="Select only suggested Event Type"
              :items="eventTypes"
              v-model="form.eventTypeID"
              label="Event Type"
              auto
              chips
              prepend-icon="attach_file"
              required
              item-text="name"
              item-value="id"
            ></v-autocomplete>

          </v-flex>
          <v-flex
            lg4
            sm4
          >
            <v-autocomplete              
              hint="Atleast 3 Characters required"         
              chips             
              flat
              placeholder="Select only suggested Reference Document"
              :items="wikilists"
              v-model="form.referenceDocument"
              label="Reference Document"
              auto
              chips
              prepend-icon="attach_file"
              required
              item-text="name"
              item-value="name"
            ></v-autocomplete>

          </v-flex>

          <v-flex
            lg12
            sm12
          >
            <p>
              <v-icon>graphic_eq</v-icon>&nbsp;&nbsp;Repeat Information?
            </p>
          </v-flex>
          <v-flex
            lg2
            sm2
          >
            <v-checkbox
              label="Repeat Information"
              value="311"
              v-model="form.repeatInfoID"
            ></v-checkbox>

          </v-flex>
          <v-flex
            lg2
            sm2
          >

            <v-checkbox
              label="By Standard Frequency"
              v-model="form.repeatInfoID"
              value="312"
            ></v-checkbox>
          </v-flex>
          <v-flex
            lg8
            sm8
          ></v-flex>

          <v-flex
            lg12
            sm12
          >
            <p>
              <v-icon>aspect_ratio</v-icon>&nbsp;&nbsp;Standard Frequency
            </p>
          </v-flex>
          <v-flex
            lg1
            sm1
          >
            <v-checkbox
              label="By Month"
              value="301"
              v-model="form.standardFrequencyID"
            ></v-checkbox>
          </v-flex>
          <v-flex
            lg1
            sm1
          >
            <v-checkbox
              label="By Week"
              value="302"
              v-model="form.standardFrequencyID"
            ></v-checkbox>
          </v-flex>
          <v-flex
            lg1
            sm1
          >
            <v-checkbox
              label="By Day"
              value="303"
              v-model="form.standardFrequencyID"
            ></v-checkbox>
          </v-flex>

          <v-flex
            lg8
            sm8
          ></v-flex>
          <v-flex
            lg12
            sm12
          >
            <p>
              <v-icon>filter_list</v-icon>&nbsp;&nbsp;Fulfilment Status
            </p>
          </v-flex>

          <v-flex
            lg2
            sm2
          >
            <v-checkbox
              label="Fulfil on the Date"
              v-model="form.fullfilmentStatus"
              value="306"
            ></v-checkbox>
          </v-flex>
          <v-flex
            lg2
            sm2
          >
            <v-checkbox
              label="Allow + or 1 days"
              v-model="form.fullfilmentStatus"
              value="307"
            ></v-checkbox>
          </v-flex>
          <v-flex
            lg1
            sm1
          >
            <p>Days</p>
          </v-flex>

          <v-flex
            lg2
            sm2
          >
            <v-checkbox
              label="Not Later by"
              v-model="form.fullfilmentStatus"
              value="308"
            ></v-checkbox>
          </v-flex>
          <v-flex
            lg2
            sm2
          >
            <v-text-field
              type="number"
              label="Days"
              suffix="Days"
            >

            </v-text-field>
          </v-flex>
          <v-flex
            lg4
            sm4
          >
            <v-menu
              :close-on-content-click="false"
              v-model="menutrigger"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <v-text-field
                slot="activator"
                v-model="form.triggerDate"
                label="Task Due Date"
                prepend-icon="event"
                readonly
              ></v-text-field>
              <v-date-picker
                v-model="form.triggerDate"
                @input="menutrigger = false"
              ></v-date-picker>
            </v-menu>

          </v-flex>

          <v-flex
            lg4
            sm4
          >

            <v-menu
              :close-on-content-click="false"
              v-model="menudue"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <v-text-field
                slot="activator"
                v-model="form.taskDueDate"
                label="Task Due Date"
                prepend-icon="event"
                readonly
              ></v-text-field>
              <v-date-picker
                v-model="form.taskDueDate"
                @input="menudue = false"
              ></v-date-picker>
            </v-menu>

          </v-flex>
          <v-flex
            lg4
            sm4
          >
            <v-textarea
              label="Task Content"
              prepend-icon="notes"
              v-model="form.taskContent"
            ></v-textarea>
          </v-flex>

        </v-layout>
      </v-form>
    </v-container>
  </div>
</template>

<script>

export default {
  components: {

  },

  data: () => ({
    menudue: false,
    menutrigger: false,
    eventTypes: [
      { name: 'ImPromptu', id: 16 },
      { name: 'Company Event', id: 17 },
      { name: 'Yearly Event', id: 18 }
    ],
    wikilists: [
      { id: 1, name: 'Temperature Mapping - Report- Intermediate Room (Granule)' },
      { id: 2, name: 'Temperature Mapping - Report (Chiller) - TMP-18-02' },
      { id: 3, name: 'PQ - ZP33 Tablet Press Machine' },
      { id: 4, name: 'PQ - Kobelco Compressed Air System (KS45A)' },
    ],
    form: {
      valid: false,
      companyEventID: -1,
      companyID: null,
      deptOwner: null,
      loginUser: 'Arun',
      isLogin: 'yes-1',
      date: new Date().toISOString().substr(0, 10),
      eventTypeID: null,
      eventType: '',
      fullfilmentStatus: null,
      isEffectProdSchdule: null,
      authorityOrCompanyRequirement: '',
      name: '',
      notLaterDays: null,
      preparationDays: null,
      preparationTypeID: null,
      reminderby: null,
      repeatInfoID: null,
      requiredPreparation: null,
      standardFrequencyID: null,
      startDate: null,
      taskContent: null,
      taskDueDate: null,
      triggerDate: null,
      addedByUserID: null,
      addedDate: new Date(),
      statusCodeID: 1,
      statusCode: 'Active',
      modifiedByUserID: null,
      modifiedDate: new Date(),
      requiredfield: [v => !!v || 'This is required field'],
      referenceDocument: '',
    }
  }),
  mounted () {
    this.$validator.localize('en', this.dictionary);
  },

  methods: {

  }
};
</script>






// WEBPACK FOOTER //
// src/pages/calendar/PPEvent.vue